@if (companyFormService.form$ | async; as companyForm) {
  <fo-toolbar>
    <ng-container leftElements>
      <fo-breadcrumb
        [lastBreadcrumbLabelOverride]="entity ? entity.name : null"
      ></fo-breadcrumb>
    </ng-container>
    @if (formType !== 'new') {
      <ng-container rightElements>
        <fo-kebab-menu [items]="kebabItems"></fo-kebab-menu>
      </ng-container>
    }
  </fo-toolbar>
  <crm-container [maxSize]="'xl'" [removeNegativeMargin]="true">
    <div class="row mx-0">
      <!-- Left -->
      <div [ngClass]="entity ? 'col-md-8' : 'col-md-12'">
        <mat-tab-group
          [selectedIndex]="selectedTabIndex.value"
          (selectedIndexChange)="onTabChange($event)"
        >
          <!-- Details -->
          <mat-tab>
            <ng-template mat-tab-label>{{
              'forms:company' | i18nextCap
            }}</ng-template>
            <div class="tab-content-padding">
              <fo-company-form
                [disabled]="disabled"
                [emailRequired]="companyEmailRequired"
                [bothTypeAllowed]="bothTypeAllowed"
                [initialValue]="entity"
                [countries]="countries$ | async"
                [potentialAssignees]="users$ | async"
                (onSave)="onSave($event)"
              />
            </div>
          </mat-tab>
          <!-- Locations -->
          @if (entity) {
            <mat-tab>
              <ng-template mat-tab-label>
                <span>
                  {{ 'forms:locations' | i18nextCap }}
                </span></ng-template
              >
              <div class="tab-content-padding">
                <fo-location-list
                  [locations$]="locations$"
                  (create)="onCreateLocation($event)"
                  (update)="onEditLocation($event)"
                  (delete)="onDeleteLocation($event)"
                />
              </div>
            </mat-tab>
          }
          <!-- Contacts -->
          @if (entity) {
            <mat-tab>
              <ng-template mat-tab-label>{{
                'forms:contacts' | i18nextCap
              }}</ng-template>
              <div class="tab-content-padding">
                <mat-accordion
                  ><mat-expansion-panel>
                    <mat-expansion-panel-header
                      [attr.data-testid]="'create-contact-accordion-header'"
                    >
                      <mat-panel-title class="contact-title">
                        <mat-icon class="green-icon">add_circle</mat-icon>
                        {{ 'translation:newContact' | i18nextCap }}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="">
                      <crm-form-template
                        [formGroup]="newContactForm"
                        [formFields]="newContactFields"
                      ></crm-form-template>
                      <div class="col-md-12">
                        <div class="buttons-right">
                          <app-button-v2
                            text="create"
                            (onClick)="createContact()"
                            color="blue"
                          ></app-button-v2>
                        </div>
                      </div>
                    </div>
                  </mat-expansion-panel>
                  @if (allContacts$ | async; as contacts) {
                    @for (contact of contacts; track contact; let i = $index) {
                      <crm-company-contact-expansion-panel
                        [contact]="contact"
                        [index]="i"
                        (editContactEvent)="editContact($event)"
                        (deleteContactEvent)="deleteContact($event)"
                      ></crm-company-contact-expansion-panel>
                    }
                  }
                </mat-accordion>
              </div>
            </mat-tab>
          }
          <!-- Equipments -->
          @if (entity) {
            <mat-tab [disabled]="!(canViewClientEquipment$ | async)">
              <ng-template mat-tab-label>
                <span
                  [matTooltip]="
                    (canViewClientEquipment$ | async)
                      ? null
                      : ('youDoNotHavePermissionToAccessThisTab' | i18nextCap)
                  "
                >
                  {{ 'forms:equipments' | i18nextCap }}
                </span></ng-template
              >
              <div class="tab-content-padding">
                @if ((canViewClientEquipment$ | async) && entity?.id) {
                  <fo-company-assets [companyId]="entity.id" />
                }
              </div>
            </mat-tab>
          }
        </mat-tab-group>
      </div>
      <!-- Right -->
      @if (entity) {
        <div class="right-col col-md-4">
          <div class="d-flex flex-column right-column-gap">
            @if (history$) {
              <crm-history [history]="$any(history$ | async)" />
            }
          </div>
        </div>
      }
    </div>
  </crm-container>
}
